import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import { rowsPerPageJsonData } from "../utils/JsonData";
import { t } from "i18next";

const initialState = {
  arrivalList: [],
  arrivalDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  arrivalDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  arrivalSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    booking_source: 0,
    ota_source: 0,
  },
  departureDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  departureDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  departureSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  departureList: [],
  avalabilityAllRoomData: [],
  roomAvailabilityResultCust: {},
  roomAvailabilityBlockRoomData: {},
  roomAvailabilityDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  roomAvailabilitySearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  housekeepingResultCust: {},
  housekeepingBlockRoomData: {},
  housekeepingDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  housekeepingSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  checkinList: [],
  checkinDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  checkinDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  checkinSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    booking_source: 0,
    ota_source: 0,
  },
  checkOutList: [],
  checkOutDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  checkOutDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  checkOutSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().add(7, "days").format("YYYY-MM-DD"),
  },
  cancellationList: [],
  cancellationDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  cancellationDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  cancellationSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  vacantRoomList: [],
  vacantRoomDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  vacantRoomDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  vacantRoomSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().add(7, "days").format("YYYY-MM-DD"),
    categoryType: 0,
  },
  revenueByRoomTypeList: [],
  revenueBreakdownList: [],
  revenueAdrList: [],
  flashDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  revenueDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  adrDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  flashSearchFilters: {
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  flashSummuryData: [],
  flashRoomSoldArr: [],
  flashRevenueSummuryData: [],
  flashAdrSummuryData: [],
  flashDataGridColumns: [
    { field: "name", headerName: t("Date"), flex: 1 },
    { field: "noOfRooms", headerName: t("No. of Rooms"), flex: 1 },
    { field: "revenue", headerName: t("Revenue"), flex: 1 },
  ],
  flashRevenueDataGridColumns: [
    { field: "name", headerName: t("Date"), flex: 1 },
  ],
  flashTab: 0,
  dailyTab: 0,
  dailyListSearchFilters: {
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  revenueDailyRevenueDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  revenueDailyOccupancyDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  revenueMonthlyRevenueDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  revenueDailyRevenueList: [],
  revenueDailyOccupancyList: [],
  revenueMonthlyRevenueList: [],
  transactionBatchData: [],
  transactionSearchFilter: {
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  transactionDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  transactionBatchSummuryData: [],
  transactionBatchDataGridColumns: [
    { field: "name", headerName: t("Date"), flex: 1 },
  ],
  hotalStatisticsList: [],
  hotalStatisticsSearchFilters: {
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  inHouseList: [],
  inhouseDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  inhouseDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  inhouseSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  houseKeepingList: [],
  noShowList: [],
  noShowDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  noShowDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  noShowSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().add(7, "days").format("YYYY-MM-DD"),
  },
  nightAuditNoShowList: [],
  nightAuditNoShowDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  nightAuditNoShowDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  nightAuditNoShowSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().add(7, "days").format("YYYY-MM-DD"),
  },
  disputeList: [],
  disputeDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  disputeDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100,
    page: 1,
  },
  disputeSearchFilters: {
    searchText: "",
    startDate: moment().subtract(2, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    type: 0,
  },
  transactionReportList: [],
  transactionReportDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  transactionReportDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100,
    page: 1,
  },
  transactionReportSearchFilters: {
    searchText: "",
    startDate: moment().subtract(2, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    type: 0,
  },
  achDepositeList: [],
  achDepositeDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  achDepositeDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100,
    page: 1,
  },
  achDepositeSearchFilters: {
    searchText: "",
    startDate: moment().subtract(2, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    type: 0,
  },
  guestList: [],
  guestDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  guestDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  guestSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().add(7, "days").format("YYYY-MM-DD"),
  },
  averageDailyRateList: [],
  averageDailyDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  averageDailySearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().add(7, "days").format("YYYY-MM-DD"),
    durationFilter: 1,
  },
  forecastList: [],
  forecastDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  forecastSearchFilters: {
    searchText: "",
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  visitorGuestList: [],
  AdrSummuryData: [],
  AdrSummuryDataExport: {},
  packageReportList: [],
  packageReportDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  packageReportSearchFilters: {
    searchText: "",
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  packageReportSummuryData: [],
  packageReportSummuryDataExport: {},

  revparList: [],
  revparDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  revparSearchFilters: {
    searchText: "",
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  revparAdrSummuryData: [],
  revparAdrSummuryDataExport: {},
  monthlyRevenueSearchFilters: {
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  monthlyRevenueReport: {
    primaryAccounts: [],
    miscAccounts: [],
    totals: {},
  },
  profitLossSearchFilters: {
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  profitLossReport: {},
  profitLossCporSearchFilters: {
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  profitLossCporReport: {},
  revenueBySourceDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  revenueBySourceSearchFilters: {
    searchText: "",
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    ota_source: 0,
  },
  revenueBySourceSummuryData: [],
  commissionBySourceDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  commissionBySourceSearchFilters: {
    searchText: "",
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    ota_source: 0,
  },
  commissionBySourceSummuryData: [],
  rateDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  rateSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().add(7, "days").format("YYYY-MM-DD"),
  },
  rateOtaCodeList: [],
  rateDataGridColumns: [
    { field: "date", headerName: t("Date"), flex: 1 },
    { field: "room_type", headerName: t("Room Type"), flex: 1 },
    { field: "web_rates", headerName: t("Web Rate"), flex: 1 },
  ],
  rateSelectedOta: [],
  rateRoomCategoryList: [],
  rateResult: {},
  rateOtaRuleData: {},
  zOutSearchFilters: {
    startDate: moment().subtract(2, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  zOutReportData: {},
  taxExempsearchFilters: {
    searchText: "",
    startDate: moment().subtract(2, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  tax_taxExempt: {},
  tax_tax_exempt_revenue_summary_by_tax: {
    tax: {
      title: "",
      col1: "",
      col2: "",
    },
    current_tax_confi: {
      title: "",
      col1: "",
      col2: "",
    },
  },
  tax_exempt_revenue: {
    exempt_revenue_through: {
      title: "",
      col1: "",
      col2: "",
    },
    exempt_revenue_ptd: {
      title: "",
      col1: 0,
      col2: 0,
    },
    exempt_revenue_ytd: {
      title: "",
      col1: 0,
      col2: 0,
    },
  },
  tax_exempt: {
    exempt_through: {
      title: "",
      col1: "",
      col2: "",
    },
    exempt_ptd: {
      title: "",
      col1: 0,
      col2: 0,
    },
    exempt_ytd: {
      title: "",
      col1: 0,
      col2: 0,
    },
  },
  tax_tax_exempt_revenue_summary_by_transaction_code: {
    tax_exempt_trans_code: {
      title: " ",
      col1: "",
      col2: "",
    },
    tc_exempt_revenue_through: {
      title: "",
      col1: "",
      col2: "",
    },
    tc_exempt_revenue_ptd: {
      title: "",
      col1: 0,
      col2: 0,
    },
    tc_exempt_revenue_ytd: {
      title: "",
      col1: 0,
      col2: 0,
    },
  },
  tax_tax_refund_revenue_summary_by_transaction_code: {
    tax_refund_trans_code: {
      title: " ",
      col1: "",
      col2: "",
    },
    tc_refund_revenue_through: {
      title: "",
      col1: "",
      col2: "",
    },
    tc_refund_revenue_ptd: {
      title: "",
      col1: 0,
      col2: 0,
    },
    tc_refund_revenue_ytd: {
      title: "",
      col1: 0,
      col2: 0,
    },
  },
  hotelJournalSummarysearchFilters: {
    searchText: "",
    startDate: moment().subtract(2, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  hotelJournalSummaryList: [
    {
      description: "",
      postings1: 0,
      corrections: 0,
      adjustments: 0,
      totals: 0,
      transactions: 0,
      post: 0,
      corr: 0,
      adj: 0,
    },
  ],
  hotelJournalSummaryDetailedTransList: [
    {
      dateTime: moment(moment().subtract(2, "days")).format(
        "MM/DD/YYYY hh:mm A",
      ),
      transactionId: "",
      description: "",
      accountType: "",
      amount: "$ 0",
      paymentMethod: "",
      department: "",
    },
  ],
  hotelJournalSummaryTotal: {
    totalOpeningBalance: 0,
    todaysTotal: 0,
    todaysAdjustments: 0,
    balanceForward: 0,
  },
  ledgerSummaryDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  ledgerSummarySearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().endOf("month").format("YYYY-MM-DD"),
  },
  glTrialBalanceDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  glTrialBalanceSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().endOf("month").format("YYYY-MM-DD"),
  },
  activityLogDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  activityLogDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  activityLogSearchFilters: {
    searchText: "",
    startDate: moment().subtract(2, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  },
  transactionBatchReport: {},
  guestsDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  guestsDatagridPrintOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100000,
    page: 1,
  },
  guestsSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().endOf("month").format("YYYY-MM-DD"),
    booking_source: 0,
    ota_source: 0,
    searchAddressText: "",
    min_amount: 1,
    max_amount: 500,
  },
  guestEmailSmsTemplate: [],
  guestSmsTemplate: [],
  guestOtaCodeList: [],
  productsDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
};
const reportSlice = createSlice({
  name: "pos",
  initialState: initialState,
  reducers: {
    arrivalListSuccess: (state, action) => {
      state.arrivalList = action.payload;
    },
    arrivalListFailed: (state, action) => {
      state.arrivalList = [];
    },
    arrivalDatagridOptionsSucces: (state, action) => {
      state.arrivalDatagridOptions = {
        ...state.arrivalDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    arrivalDatagridPrintOptionsSucces: (state, action) => {
      state.arrivalDatagridPrintOptions = {
        ...state.arrivalDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    arrivalSearchFilterSucces: (state, action) => {
      state.arrivalSearchFilters = {
        ...state.arrivalSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    departureListSuccess: (state, action) => {
      state.departureList = action.payload;
    },
    departureListFailed: (state, action) => {
      state.departureList = [];
    },
    departureDatagridOptionsSucces: (state, action) => {
      state.departureDatagridOptions = {
        ...state.departureDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    departureDatagridPrintOptionsSucces: (state, action) => {
      state.departureDatagridPrintOptions = {
        ...state.departureDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    departureSearchFilterSucces: (state, action) => {
      state.departureSearchFilters = {
        ...state.departureSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    avalabilityAllRoomDataSuccess: (state, action) => {
      state.avalabilityAllRoomData = action.payload;
    },
    roomAvailabilityResultCustSuccess: (state, action) => {
      state.roomAvailabilityResultCust = action.payload;
    },
    roomAvailabilityBlockRoomDataSuccess: (state, action) => {
      state.roomAvailabilityBlockRoomData = action.payload;
    },
    roomAvailabilityDatagridOptionsSucces: (state, action) => {
      state.roomAvailabilityDatagridOptions = {
        ...state.roomAvailabilityDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    roomAvailabilitySearchFilterSucces: (state, action) => {
      state.roomAvailabilitySearchFilters = {
        ...state.roomAvailabilitySearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    housekeepingResultCustSuccess: (state, action) => {
      state.housekeepingResultCust = action.payload;
    },
    housekeepingBlockRoomDataSuccess: (state, action) => {
      state.housekeepingBlockRoomData = action.payload;
    },
    housekeepingDatagridOptionsSucces: (state, action) => {
      state.housekeepingDatagridOptions = {
        ...state.housekeepingDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    housekeepingSearchFilterSucces: (state, action) => {
      state.housekeepingSearchFilters = {
        ...state.housekeepingSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    checkinListSuccess: (state, action) => {
      state.checkinList = action.payload;
    },
    checkinListFailed: (state, action) => {
      state.checkinList = [];
    },
    checkinDatagridOptionsSucces: (state, action) => {
      state.checkinDatagridOptions = {
        ...state.checkinDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    checkinDatagridPrintOptionsSucces: (state, action) => {
      state.checkinDatagridPrintOptions = {
        ...state.checkinDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    checkinSearchFilterSucces: (state, action) => {
      state.checkinSearchFilters = {
        ...state.checkinSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    checkOutListSuccess: (state, action) => {
      state.checkOutList = action.payload;
    },
    checkOutListFailed: (state, action) => {
      state.checkOutList = [];
    },
    checkOutDatagridOptionsSuccess: (state, action) => {
      state.checkOutDatagridOptions = {
        ...state.checkOutDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    checkOutDatagridPrintOptionsSuccess: (state, action) => {
      state.checkOutDatagridPrintOptions = {
        ...state.checkOutDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    checkOutSearchFilterSuccess: (state, action) => {
      state.checkOutSearchFilters = {
        ...state.checkOutSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    cancellationListSuccess: (state, action) => {
      state.cancellationList = action.payload;
    },
    cancellationListFailed: (state, action) => {
      state.cancellationList = [];
    },
    cancellationDatagridOptionsSuccess: (state, action) => {
      state.cancellationDatagridOptions = {
        ...state.cancellationDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    cancellationDatagridPrintOptionsSuccess: (state, action) => {
      state.cancellationDatagridPrintOptions = {
        ...state.cancellationDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    cancellationSearchFilterSuccess: (state, action) => {
      state.cancellationSearchFilters = {
        ...state.cancellationSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    vacantRoomListSuccess: (state, action) => {
      state.vacantRoomList = action.payload;
    },
    vacantRoomListFailed: (state, action) => {
      state.vacantRoomList = [];
    },
    vacantRoomDatagridOptionsSuccess: (state, action) => {
      state.vacantRoomDatagridOptions = {
        ...state.vacantRoomDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    vacantRoomDatagridPrintOptionsSuccess: (state, action) => {
      state.vacantRoomDatagridPrintOptions = {
        ...state.vacantRoomDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    vacantRoomSearchFilterSuccess: (state, action) => {
      state.vacantRoomSearchFilters = {
        ...state.vacantRoomSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    revenueByRoomTypeListSuccess: (state, action) => {
      state.revenueByRoomTypeList = action.payload;
    },
    revenueByRoomTypeListFailed: (state, action) => {
      state.revenueByRoomTypeList = [];
    },
    revenueBreakdownListSuccess: (state, action) => {
      state.revenueBreakdownList = action.payload;
    },
    revenueBreakdownListFailed: (state, action) => {
      state.revenueBreakdownList = [];
    },
    revenueAdrListSuccess: (state, action) => {
      state.revenueAdrList = action.payload;
    },
    revenueAdrListFailed: (state, action) => {
      state.revenueAdrList = [];
    },
    flashDatagridOptionsSuccess: (state, action) => {
      state.flashDatagridOptions = {
        ...state.flashDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    revenueDatagridOptionsSuccess: (state, action) => {
      state.revenueDatagridOptions = {
        ...state.revenueDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    adrDatagridOptionsSuccess: (state, action) => {
      state.adrDatagridOptions = {
        ...state.adrDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    flashSearchFilterSuccess: (state, action) => {
      state.flashSearchFilters = {
        ...state.flashSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },

    flashTabSuccess: (state, action) => {
      state.flashTab = action.payload;
    },
    flashSummuryDataSuccess: (state, action) => {
      state.flashSummuryData = action.payload;
    },
    flashRoomSoldArrSuccess: (state, action) => {
      state.flashRoomSoldArr = action.payload;
    },
    flashRevenueSummuryDataSuccess: (state, action) => {
      state.flashRevenueSummuryData = action.payload;
    },
    flashAdrSummuryDataSuccess: (state, action) => {
      state.flashAdrSummuryData = action.payload;
    },
    flashDataGridColumnsSuccess: (state, action) => {
      state.flashDataGridColumns = action.payload;
    },
    flashRevenueDataGridColumnsSuccess: (state, action) => {
      state.flashRevenueDataGridColumns = action.payload;
    },
    dailyListSearchFiltersSuccess: (state, action) => {
      state.dailyListSearchFilters = {
        ...state.dailyListSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    dailyTabSuccess: (state, action) => {
      state.dailyTab = action.payload;
    },
    revenueDailyRevenueDatagridOptionsSuccess: (state, action) => {
      state.revenueDailyRevenueDatagridOptions = {
        ...state.revenueDailyRevenueDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    revenueDailyOccupancyDatagridOptionsSuccess: (state, action) => {
      state.revenueDailyOccupancyDatagridOptions = {
        ...state.revenueDailyOccupancyDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    revenueMonthlyRevenueDatagridOptionsSuccess: (state, action) => {
      state.revenueMonthlyRevenueDatagridOptions = {
        ...state.revenueMonthlyRevenueDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    revenueDailyRevenueListSuccess: (state, action) => {
      state.revenueDailyRevenueList = action.payload;
    },
    revenueDailyOccupancyListSuccess: (state, action) => {
      state.revenueDailyOccupancyList = action.payload;
    },
    revenueMonthlyRevenueListSuccess: (state, action) => {
      state.revenueMonthlyRevenueList = action.payload;
    },
    transactionBatchDataSuccess: (state, action) => {
      state.transactionBatchData = action.payload;
    },
    transactionBatchDataSuccess: (state, action) => {
      state.transactionBatchData = action.payload;
    },
    transactionBatchDataFailed: (state, action) => {
      state.transactionBatchData = [];
    },
    transactionDatagridOptionsSuccess: (state, action) => {
      state.transactionDatagridOptions = {
        ...state.transactionDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    transactionSearchFilterSuccess: (state, action) => {
      state.transactionSearchFilter = {
        ...state.transactionSearchFilter,
        [action.payload.key]: action.payload.value,
      };
    },
    transactionBatchSummuryDataSuccess: (state, action) => {
      state.transactionBatchSummuryData = action.payload;
    },
    transactionBatchDataGridColumnsSuccess: (state, action) => {
      state.transactionBatchDataGridColumns = action.payload;
    },
    hotalStatisticsListSuccess: (state, action) => {
      state.hotalStatisticsList = action.payload;
    },
    hotalStatisticsSearchFilterSuccess: (state, action) => {
      state.hotalStatisticsSearchFilters = {
        ...state.hotalStatisticsSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    inHouseListSuccess: (state, action) => {
      state.inHouseList = action.payload;
    },
    inHouseListFailed: (state, action) => {
      state.inHouseList = [];
    },
    inhouseDatagridOptionsSucces: (state, action) => {
      state.inhouseDatagridOptions = {
        ...state.inhouseDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    inhouseDatagridPrintOptionsSucces: (state, action) => {
      state.inhouseDatagridPrintOptions = {
        ...state.inhouseDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    inhouseSearchFilterSucces: (state, action) => {
      state.inhouseSearchFilters = {
        ...state.inhouseSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    houseKeepingListSuccess: (state, action) => {
      state.houseKeepingList = action.payload;
    },
    houseKeepingListFailed: (state, action) => {
      state.houseKeepingList = [];
    },
    noShowListSuccess: (state, action) => {
      state.noShowList = action.payload;
    },
    noShowListFailed: (state, action) => {
      state.noShowList = [];
    },
    noShowDatagridOptionsSuccess: (state, action) => {
      state.noShowDatagridOptions = {
        ...state.noShowDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    noShowDatagridPrintOptionsSuccess: (state, action) => {
      state.noShowDatagridPrintOptions = {
        ...state.noShowDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    noShowSearchFilterSuccess: (state, action) => {
      state.noShowSearchFilters = {
        ...state.noShowSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    nightAuditNoShowListSuccess: (state, action) => {
      state.nightAuditNoShowList = action.payload;
    },
    nightAuditNoShowDatagridOptionsSuccess: (state, action) => {
      state.nightAuditNoShowDatagridOptions = {
        ...state.nightAuditNoShowDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    nightAuditNoShowDatagridPrintOptionsSuccess: (state, action) => {
      state.nightAuditNoShowDatagridPrintOptions = {
        ...state.nightAuditNoShowDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    nightAuditNoShowSearchFiltersSuccess: (state, action) => {
      state.nightAuditNoShowSearchFilters = {
        ...state.nightAuditNoShowSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    disputeListSuccess: (state, action) => {
      state.disputeList = action.payload;
    },
    disputeDatagridOptionsSuccess: (state, action) => {
      state.disputeDatagridOptions = {
        ...state.disputeDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    disputeDatagridPrintOptionsSuccess: (state, action) => {
      state.disputeDatagridPrintOptions = {
        ...state.disputeDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    disputeSearchFiltersSuccess: (state, action) => {
      state.disputeSearchFilters = {
        ...state.disputeSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    transactionReportListSuccess: (state, action) => {
      state.transactionReportList = action.payload;
    },
    transactionReportDatagridOptionsSuccess: (state, action) => {
      state.transactionReportDatagridOptions = {
        ...state.transactionReportDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    transactionReportDatagridPrintOptionsSuccess: (state, action) => {
      state.transactionReportDatagridPrintOptions = {
        ...state.transactionReportDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    transactionReportSearchFiltersSuccess: (state, action) => {
      state.transactionReportSearchFilters = {
        ...state.transactionReportSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    achDepositeListSuccess: (state, action) => {
      state.achDepositeList = action.payload;
    },
    achDepositeDatagridOptionsSuccess: (state, action) => {
      state.achDepositeDatagridOptions = {
        ...state.achDepositeDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    achDepositeDatagridPrintOptionsSuccess: (state, action) => {
      state.achDepositeDatagridPrintOptions = {
        ...state.achDepositeDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    achDepositeSearchFiltersSuccess: (state, action) => {
      state.achDepositeSearchFilters = {
        ...state.achDepositeSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    guestListSuccess: (state, action) => {
      state.guestList = action.payload;
    },
    guestListFailed: (state, action) => {
      state.guestList = [];
    },
    guestDatagridOptionsSuccess: (state, action) => {
      state.guestDatagridOptions = {
        ...state.guestDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    guestDatagridPrintOptionsSuccess: (state, action) => {
      state.guestDatagridPrintOptions = {
        ...state.guestDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    guestSearchFilterSuccess: (state, action) => {
      state.guestSearchFilters = {
        ...state.guestSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    visitorGuestListSuccess: (state, action) => {
      state.visitorGuestList = action.payload;
    },
    visitorGuestListFailed: (state, action) => {
      state.visitorGuestList = [];
    },
    averageDailyRateListSuccess: (state, action) => {
      state.averageDailyRateList = action.payload;
    },
    averageDailyRateListFailed: (state, action) => {
      state.averageDailyRateList = [];
    },

    AdrSummuryDataSuccess: (state, action) => {
      state.AdrSummuryData = action.payload;
    },
    AdrSummuryDataExportSuccess: (state, action) => {
      state.AdrSummuryDataExport = action.payload;
    },
    forecastListSuccess: (state, action) => {
      state.forecastList = action.payload;
    },
    forecastListFailed: (state, action) => {
      state.forecastList = [];
    },
    forecastDatagridOptionsSuccess: (state, action) => {
      state.forecastDatagridOptions = {
        ...state.forecastDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    forecastSearchFilterSuccess: (state, action) => {
      state.forecastSearchFilters = {
        ...state.forecastSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
      packageReportSummuryDataSuccess: (state, action) => {
        state.packageReportSummuryData = action.payload;
      },
      packageReportSummuryDataExportSuccess: (state, action) => {
        state.packageReportSummuryDataExport = action.payload;
      },
      packageReportListSuccess: (state, action) => {
        state.packageReportList = action.payload;
      },
      packageReportListFailed: (state, action) => {
        state.packageReportList = [];
      },
      packageReportDatagridOptionsSuccess: (state, action) => {
        state.packageReportDatagridOptions = {
          ...state.packageReportDatagridOptions,
          [action.payload.key]: action.payload.value,
        };
      },
      packageReportSearchFilterSuccess: (state, action) => {
        state.packageReportSearchFilters = {
          ...state.packageReportSearchFilters,
          [action.payload.key]: action.payload.value,
        };
      },
    averageDailyDatagridOptionSuccess: (state, action) => {
      state.averageDailyDatagridOptions = {
        ...state.averageDailyDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    averageDailySearchFiltersSuccess: (state, action) => {
      state.averageDailySearchFilters = {
        ...state.averageDailySearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    revparListSuccess: (state, action) => {
      state.revparList = action.payload;
    },
    revparListFailed: (state, action) => {
      state.revparList = [];
    },
    revparDatagridOptionsSuccess: (state, action) => {
      state.revparDatagridOptions = {
        ...state.revparDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    revparSearchFilterSuccess: (state, action) => {
      state.revparSearchFilters = {
        ...state.revparSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    revparAdrSummuryDataSuccess: (state, action) => {
      state.revparAdrSummuryData = action.payload;
    },
    revparAdrSummuryDataExportSuccess: (state, action) => {
      state.revparAdrSummuryDataExport = action.payload;
    },
    monthlyRevenueReportSuccess: (state, action) => {
      state.monthlyRevenueReport = action.payload;
    },
    monthlyRevenueSearchFilterSuccess: (state, action) => {
      state.monthlyRevenueSearchFilters = {
        ...state.monthlyRevenueSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    profitLossReportSuccess: (state, action) => {
      state.profitLossReport = action.payload;
    },
    profitLossSearchFilterSuccess: (state, action) => {
      state.profitLossSearchFilters = {
        ...state.profitLossSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    profitLossCporReportSuccess: (state, action) => {
      state.profitLossCporReport = action.payload;
    },
    profitLossCporSearchFilterSuccess: (state, action) => {
      state.profitLossCporSearchFilters = {
        ...state.profitLossCporSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    revenueBySourceDatagridOptionsSuccess: (state, action) => {
      state.revenueBySourceDatagridOptions = {
        ...state.revenueBySourceDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    revenueBySourceSummuryDataSuccess: (state, action) => {
      state.revenueBySourceSummuryData = action.payload;
    },
    revenueBySourceSearchFiltersSuccess: (state, action) => {
      state.revenueBySourceSearchFilters = {
        ...state.revenueBySourceSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    commissionBySourceDatagridOptionsSuccess: (state, action) => {
      state.commissionBySourceDatagridOptions = {
        ...state.commissionBySourceDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    commissionBySourceSummuryDataSuccess: (state, action) => {
      state.commissionBySourceSummuryData = action.payload;
    },
    commissionBySourceSearchFiltersSuccess: (state, action) => {
      state.commissionBySourceSearchFilters = {
        ...state.commissionBySourceSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    rateDatagridOptionsSuccess: (state, action) => {
      state.rateDatagridOptions = {
        ...state.rateDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    rateSearchFiltersSuccess: (state, action) => {
      state.rateSearchFilters = {
        ...state.rateSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    rateOtaCodeListSuccess: (state, action) => {
      state.rateOtaCodeList = action.payload;
    },
    guestOtaCodeListSuccess: (state, action) => {
      state.guestOtaCodeList = action.payload;
    },
    rateDataGridColumnsSuccess: (state, action) => {
      state.rateDataGridColumns = action.payload;
    },
    rateSelectedOtaSuccess: (state, action) => {
      state.rateSelectedOta = action.payload;
    },
    rateRoomCategoryListSuccess: (state, action) => {
      state.rateRoomCategoryList = action.payload;
    },
    rateResultSuccess: (state, action) => {
      state.rateResult = action.payload;
    },
    rateOtaRuleDataSuccess: (state, action) => {
      state.rateOtaRuleData = action.payload;
    },
    zOutSearchFiltersSuccess: (state, action) => {
      state.zOutSearchFilters = {
        ...state.zOutSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    zOutReportDataSuccess: (state, action) => {
      state.zOutReportData = action.payload;
    },
    taxExempsearchFiltersSuccess: (state, action) => {
      state.taxExempsearchFilters = {
        ...state.taxExempsearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    tax_taxExemptSuccess: (state, action) => {
      state.tax_taxExempt = action.payload;
    },
    tax_tax_exempt_revenue_summary_by_taxSuccess: (state, action) => {
      state.tax_tax_exempt_revenue_summary_by_tax = action.payload;
    },
    tax_exempt_revenueSuccess: (state, action) => {
      state.tax_exempt_revenue = action.payload;
    },
    tax_exemptSuccess: (state, action) => {
      state.tax_exempt = action.payload;
    },
    tax_tax_exempt_revenue_summary_by_transaction_codeSuccess: (
      state,
      action,
    ) => {
      state.tax_tax_exempt_revenue_summary_by_transaction_code = action.payload;
    },
    tax_tax_refund_revenue_summary_by_transaction_codeSuccess: (
      state,
      action,
    ) => {
      state.tax_tax_refund_revenue_summary_by_transaction_code = action.payload;
    },
    hotelJournalSummarysearchFiltersSuccess: (state, action) => {
      state.hotelJournalSummarysearchFilters = {
        ...state.hotelJournalSummarysearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    hotelJournalSummaryListSuccess: (state, action) => {
      state.hotelJournalSummaryList = action.payload;
    },
    hotelJournalSummaryDetailedTransListSuccess: (state, action) => {
      state.hotelJournalSummaryDetailedTransList = action.payload;
    },
    hotelJournalSummaryTotalSuccess: (state, action) => {
      state.hotelJournalSummaryTotal = action.payload;
    },
    ledgerSummaryDatagridOptionsSuccess: (state, action) => {
      state.ledgerSummaryDatagridOptions = {
        ...state.ledgerSummaryDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    ledgerSummarySearchFiltersSuccess: (state, action) => {
      state.ledgerSummarySearchFilters = {
        ...state.ledgerSummarySearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    glTrialBalanceDatagridOptionsSuccess: (state, action) => {
      state.glTrialBalanceDatagridOptions = {
        ...state.glTrialBalanceDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    glTrialBalanceSearchFiltersSuccess: (state, action) => {
      state.glTrialBalanceSearchFilters = {
        ...state.glTrialBalanceSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    activityLogDatagridOptionsSucces: (state, action) => {
      state.activityLogDatagridOptions = {
        ...state.activityLogDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    activityLogDatagridPrintOptionsSucces: (state, action) => {
      state.activityLogDatagridPrintOptions = {
        ...state.activityLogDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    activityLogSearchFiltersSucces: (state, action) => {
      state.activityLogSearchFilters = {
        ...state.activityLogSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    guestsDatagridOptionsSucces: (state, action) => {
      state.guestsDatagridOptions = {
        ...state.guestsDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    guestsDatagridPrintOptionsSucces: (state, action) => {
      state.guestsDatagridPrintOptions = {
        ...state.guestsDatagridPrintOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    guestsSearchFiltersSucces: (state, action) => {
      state.guestsSearchFilters = {
        ...state.guestsSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    guestEmailSmsTemplateSuccess: (state, action) => {
      state.guestEmailSmsTemplate = action.payload;
    },
    guestSmsTemplateSuccess: (state, action) => {
      state.guestSmsTemplate = action.payload;
    },
    productsDataGridOptionsSucces: (state, action) => {
      state.productsDataGridOptions = {
        ...state.productsDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
  },
});

export const {
  arrivalListSuccess,
  arrivalListFailed,
  arrivalDatagridOptionsSucces,
  arrivalDatagridPrintOptionsSucces,
  arrivalSearchFilterSucces,
  departureListSuccess,
  departureListFailed,
  departureDatagridOptionsSucces,
  departureDatagridPrintOptionsSucces,
  departureSearchFilterSucces,
  avalabilityAllRoomDataSuccess,
  roomAvailabilityResultCustSuccess,
  roomAvailabilityBlockRoomDataSuccess,
  roomAvailabilityDatagridOptionsSucces,
  roomAvailabilitySearchFilterSucces,
  housekeepingResultCustSuccess,
  housekeepingBlockRoomDataSuccess,
  housekeepingDatagridOptionsSucces,
  housekeepingSearchFilterSucces,
  checkinListSuccess,
  checkinListFailed,
  checkinDatagridOptionsSucces,
  checkinDatagridPrintOptionsSucces,
  checkinSearchFilterSucces,
  checkOutListSuccess,
  checkOutListFailed,
  checkOutDatagridOptionsSuccess,
  checkOutDatagridPrintOptionsSuccess,
  checkOutSearchFilterSuccess,
  cancellationListSuccess,
  cancellationListFailed,
  cancellationDatagridOptionsSuccess,
  cancellationDatagridPrintOptionsSuccess,
  cancellationSearchFilterSuccess,
  vacantRoomListSuccess,
  vacantRoomListFailed,
  vacantRoomDatagridOptionsSuccess,
  vacantRoomDatagridPrintOptionsSuccess,
  vacantRoomSearchFilterSuccess,
  revenueByRoomTypeListSuccess,
  revenueByRoomTypeListFailed,
  revenueBreakdownListSuccess,
  revenueBreakdownListFailed,
  revenueAdrListSuccess,
  revenueAdrListFailed,
  flashDatagridOptionsSuccess,
  revenueDatagridOptionsSuccess,
  adrDatagridOptionsSuccess,
  flashSearchFilterSuccess,
  flashTabSuccess,
  flashSummuryDataSuccess,
  flashRoomSoldArrSuccess,
  flashRevenueSummuryDataSuccess,
  flashAdrSummuryDataSuccess,
  flashDataGridColumnsSuccess,
  flashRevenueDataGridColumnsSuccess,
  dailyListSearchFiltersSuccess,
  dailyTabSuccess,
  revenueDailyRevenueDatagridOptionsSuccess,
  revenueDailyOccupancyDatagridOptionsSuccess,
  revenueMonthlyRevenueDatagridOptionsSuccess,
  revenueDailyRevenueListSuccess,
  revenueDailyOccupancyListSuccess,
  revenueMonthlyRevenueListSuccess,
  transactionBatchDataSuccess,
  transactionBatchDataFailed,
  transactionDatagridOptionsSuccess,
  transactionSearchFilterSuccess,
  transactionBatchSummuryDataSuccess,
  transactionBatchDataGridColumnsSuccess,
  hotalStatisticsListSuccess,
  hotalStatisticsSearchFilterSuccess,
  inHouseListSuccess,
  inHouseListFailed,
  inhouseDatagridOptionsSucces,
  inhouseDatagridPrintOptionsSucces,
  inhouseSearchFilterSucces,
  inhouseDatagridOptions,
  inhouseDatagridPrintOptions,
  inhouseSearchFilters,
  houseKeepingListSuccess,
  houseKeepingListFailed,
  noShowListSuccess,
  noShowListFailed,
  noShowDatagridOptionsSuccess,
  noShowDatagridPrintOptionsSuccess,
  noShowSearchFilterSuccess,
  nightAuditNoShowListSuccess,
  nightAuditNoShowDatagridOptionsSuccess,
  nightAuditNoShowDatagridPrintOptionsSuccess,
  nightAuditNoShowSearchFiltersSuccess,
  disputeListSuccess,
  disputeDatagridOptionsSuccess,
  disputeDatagridPrintOptionsSuccess,
  disputeSearchFiltersSuccess,
  transactionReportListSuccess,
  transactionReportDatagridOptionsSuccess,
  transactionReportDatagridPrintOptionsSuccess,
  transactionReportSearchFiltersSuccess,
  achDepositeListSuccess,
  achDepositeDatagridOptionsSuccess,
  achDepositeDatagridPrintOptionsSuccess,
  achDepositeSearchFiltersSuccess,
  guestListSuccess,
  guestListFailed,
  guestDatagridOptionsSuccess,
  guestDatagridPrintOptionsSuccess,
  guestSearchFilterSuccess,
  averageDailyRateListSuccess,
  averageDailyRateListFailed,
  averageDailyDatagridOptionSuccess,
  averageDailySearchFiltersSuccess,
  forecastListSuccess,
  forecastListFailed,
  visitorGuestListSuccess,
  visitorGuestListFailed,
  forecastDatagridOptionsSuccess,
  forecastSearchFilterSuccess,
  AdrSummuryDataSuccess,
  AdrSummuryDataExportSuccess,
  packageReportSummuryDataSuccess,
packageReportSummuryDataExportSuccess,
packageReportListSuccess,
packageReportListFailed,
packageReportDatagridOptionsSuccess,
packageReportSearchFilterSuccess,
  revparListSuccess,
  revparListFailed,
  revparDatagridOptionsSuccess,
  revparSearchFilterSuccess,
  revparAdrSummuryDataExportSuccess,
  revparAdrSummuryDataSuccess,
  monthlyRevenueReportSuccess,
  monthlyRevenueSearchFilterSuccess,
  profitLossReportSuccess,
  profitLossSearchFilterSuccess,
  profitLossCporReportSuccess,
  profitLossCporSearchFilterSuccess,
  revenueBySourceDatagridOptionsSuccess,
  revenueBySourceSummuryDataSuccess,
  revenueBySourceSearchFiltersSuccess,
  commissionBySourceSummuryDataSuccess,
  commissionBySourceDatagridOptionsSuccess,
  commissionBySourceSearchFiltersSuccess,
  rateDatagridOptionsSuccess,
  rateSearchFiltersSuccess,
  rateOtaCodeListSuccess,
  rateDataGridColumnsSuccess,
  rateSelectedOtaSuccess,
  rateRoomCategoryListSuccess,
  rateResultSuccess,
  rateOtaRuleDataSuccess,
  zOutSearchFiltersSuccess,
  zOutReportDataSuccess,
  taxExempsearchFiltersSuccess,
  tax_taxExemptSuccess,
  tax_tax_exempt_revenue_summary_by_taxSuccess,
  tax_exempt_revenueSuccess,
  tax_exemptSuccess,
  tax_tax_exempt_revenue_summary_by_transaction_codeSuccess,
  tax_tax_refund_revenue_summary_by_transaction_codeSuccess,
  hotelJournalSummarysearchFiltersSuccess,
  hotelJournalSummaryListSuccess,
  hotelJournalSummaryDetailedTransListSuccess,
  hotelJournalSummaryTotalSuccess,
  ledgerSummaryDatagridOptionsSuccess,
  ledgerSummarySearchFiltersSuccess,
  glTrialBalanceDatagridOptionsSuccess,
  glTrialBalanceSearchFiltersSuccess,
  activityLogDatagridOptionsSucces,
  activityLogDatagridPrintOptionsSucces,
  activityLogSearchFiltersSucces,
  guestsDatagridOptionsSucces,
  guestsDatagridPrintOptionsSucces,
  guestsSearchFiltersSucces,
  guestOtaCodeListSuccess,
  guestEmailSmsTemplateSuccess,
  guestSmsTemplateSuccess,
  productsDataGridOptionsSucces,
} = reportSlice.actions;
export default reportSlice.reducer;
